import { ParseProduction } from './parse-production';

export class ParseProductionImplementationPvSol extends ParseProduction {

  findColumnsProduction(csvData: string[][]): number {
    const firstRow = csvData[0];
    return firstRow.findIndex((value: string) => value.startsWith('Grid Feed-in') || value.startsWith('Grid Export'));
  }

  findRowProduction(csvData: string[][]): number {
    return csvData.findIndex((row: string[]) => row[0].startsWith('01.01.'));
  }

  get dateFormat() {
    return 'DD.MM. HH:mm';
  }
}
